import NiceModal, { useModal } from '@ebay/nice-modal-react';
import { useTranslation } from 'next-i18next';
import { Modal } from '@components/common/Modal/Modal';
import { JobDetail } from '@components/templates/job/detail/JobDetail';

/** Props */
interface JobDetailModalProps {
  locale: Locale;
  jobData?: ApiSchema<'JobRead'>;
}

/**
 * @description Renders the job detail modal.
 * - `locale` - The locale.
 * - `jobData` - The job data.
 */
export const JobDetailModal = NiceModal.create((props: JobDetailModalProps) => {
  // Destructure props
  const {
    locale,
    jobData,
  } = props;

  // Use a hook to manage the modal state
  const modal = useModal();

  // Close modal
  const closeModal = () => {
    void modal.hide();
  };

  // Translation
  const { t } = useTranslation('common');

  // Render component
  // *************************
  return (
    <Modal
      isOpen={modal.visible}
      onClose={closeModal}
      size="xl"
      header={t('job.preview.link')}
      body={(
        <JobDetail
          locale={locale}
          job={jobData as never}
          closeModal={closeModal}
          isSinglePage
          mode="preview"
          hideNavigation
        />
      )}
    />
  );
});

/**
 * @description Show the job detail modal.
 * - `locale` - The locale.
 * - `jobData` - The job data.
 *
 * @example
 * import { showJobDetailModal } from '@components/templates/job-add/edit/modals/JobPreviewModal';
 * showJobDetailModal({ locale, jobData });
 */
export const showJobDetailModal = (props: JobDetailModalProps) => {
  void NiceModal.show(JobDetailModal, props);
};
